import createReactClass from 'create-react-class';
'use strict';

// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
// Import class
import { builderDispatch }   from '../_utils/ui';
import CartItemsChangeEvents from './cart-items-change-events';

const LOCATION_SELECTED_MESSAGE_PREFIX = /^selected-collection-location:/,
      POSTAL_CODE_MESSAGE_PREFIX       = /^postal-code:/;

// -----------------------------------------------------------
//  CollectionPointLocator
// -----------------------------------------------------------
const CollectionPointLocator = createReactClass({
  UNSAFE_componentWillMount() {
    if (typeof window.addEventListener == 'function')
      window.addEventListener('message', this.handleMessage, false);
  },
  componentWillUnmount() {
    if (typeof window.removeEventListener == 'function')
      window.removeEventListener('message', this.handleMessage, false);
  },
  render() {
    return (
      <iframe src={ this.context.urls.collectionPointLocator + '?q=' + this.context.zipCode }
              frameBorder="no"
              style={ {width: '100%',height: (window.innerHeight - 200) + 'px'} } />
    );
  },

  handleMessage(e) {
    if (e.origin !== window.location.origin)
      return;

    const message = e.data.toString();

    if (message.match(LOCATION_SELECTED_MESSAGE_PREFIX)) {
      try {
        const location = JSON.parse(message.replace(LOCATION_SELECTED_MESSAGE_PREFIX, ''));
        this.handleLocationSelected(location);
      } catch (SyntaxError) { }
      return;
    }

    if (message.match(POSTAL_CODE_MESSAGE_PREFIX)) {
      this.handlePostalCodeChanged(message.replace(POSTAL_CODE_MESSAGE_PREFIX, ''));
    }
  },

  handleLocationSelected(location) {
    builderDispatch.dispatch({
      type: CartItemsChangeEvents.PICKUP_LOCATION_CHANGE,
      value: location.id
    });

    this.props.onSelected();
  },

  handlePostalCodeChanged: function(value) {
    builderDispatch.dispatch({
      type: CartItemsChangeEvents.ZIP_CODE_CHANGE,
      value: value.toUpperCase()
    });
  }
});

CollectionPointLocator.displayName = 'Collection Point Locator';

CollectionPointLocator.contextTypes = {
  zipCode: PropTypes.string,
  urls: PropTypes.shape({
    collectionPointLocator: PropTypes.string
  })
};

export default CollectionPointLocator;
